/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    WatchlistSymbolDto,
    WatchlistSymbolDtoFromJSON,
    WatchlistSymbolDtoFromJSONTyped,
    WatchlistSymbolDtoToJSON,
} from './WatchlistSymbolDto';

/**
 * 
 * @export
 * @interface PaginatedWatchlistSymbolDto
 */
export interface PaginatedWatchlistSymbolDto {
    /**
     * 
     * @type {number}
     * @memberof PaginatedWatchlistSymbolDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedWatchlistSymbolDto
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedWatchlistSymbolDto
     */
    offset: number;
    /**
     * 
     * @type {Array<WatchlistSymbolDto>}
     * @memberof PaginatedWatchlistSymbolDto
     */
    items: Array<WatchlistSymbolDto>;
}

export function PaginatedWatchlistSymbolDtoFromJSON(json: any): PaginatedWatchlistSymbolDto {
    return PaginatedWatchlistSymbolDtoFromJSONTyped(json, false);
}

export function PaginatedWatchlistSymbolDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedWatchlistSymbolDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
        'items': ((json['items'] as Array<any>).map(WatchlistSymbolDtoFromJSON)),
    };
}

export function PaginatedWatchlistSymbolDtoToJSON(value?: PaginatedWatchlistSymbolDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'limit': value.limit,
        'offset': value.offset,
        'items': ((value.items as Array<any>).map(WatchlistSymbolDtoToJSON)),
    };
}

